/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, auditorName: NonNullable<unknown> }} Audit_Session_DescriptionInputs */

const en_audit_session_description = /** @type {(inputs: Audit_Session_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} — Auditor: ${i?.auditorName}`)
};

const es_audit_session_description = /** @type {(inputs: Audit_Session_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} — Auditor: ${i?.auditorName}`)
};

/**
* | output |
* | --- |
* | "{date} — Auditor: {auditorName}" |
*
* @param {Audit_Session_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_session_description = /** @type {((inputs: Audit_Session_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Session_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_session_description(inputs)
	return es_audit_session_description(inputs)
});